/**
 * src/shell/ui/components/StatusBar.tsx — 顶部常驻状态条 + 右上角模式入口（设计稿 S1）。
 * 模式入口：极简/专家两选项，专家 v2 灰置禁用（2026-08-12 拍板，预留接口）。
 */

import { COPY } from '../../copy'
import { useSave } from '../../gm-client/hooks'

export function StatusBar() {
  const { bundle } = useSave()
  const save = bundle.save
  return (
    <div className="status-bar">
      <span className="status-item">
        {save.company_name} · {save.player_title}
      </span>
      <span className="status-item">Lv.{save.level}</span>
      <span className="status-item status-funds">
        {COPY.computer.ledger.funds} {save.funds}
      </span>
      <span className="status-item">
        {COPY.computer.ledger.exp} {save.exp}
      </span>
      <span className="mode-switch" title={COPY.cockpit.modeExpertTip}>
        <button className="mode-btn mode-active" type="button">
          {COPY.cockpit.modeMinimal}
        </button>
        <button className="mode-btn" type="button" disabled>
          {COPY.cockpit.modeExpert}
        </button>
      </span>
    </div>
  )
}
